import { render, staticRenderFns } from "./HBanner.vue?vue&type=template&id=1215fc01&scoped=true&"
import script from "./HBanner.vue?vue&type=script&lang=js&"
export * from "./HBanner.vue?vue&type=script&lang=js&"
import style0 from "./HBanner.vue?vue&type=style&index=0&id=1215fc01&lang=less&scoped=true&"
import style1 from "./HBanner.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215fc01",
  null
  
)

export default component.exports